import determineNotificationType from "../../../objects/CommonUse/determine_notification_type";

export const createNotificationsFromIconTable = (iconTable) => {
 
    var notificationArr = [];
    for (let i=0; i<iconTable.length; i++){
        if (iconTable[i].firstTime === true){
                const notificationType = determineNotificationType(iconTable[i]);
                const notificationObj = {
                    variety: "notification", 
                    category: iconTable[i].iconCategory, 
                    type: notificationType, 
                    additionalInfo: iconTable[i].additionalInfo,
                    nbrMonths: iconTable[i].firstTime, 
                    imageSrc: iconTable[i].imageSrc};
                notificationArr.push(notificationObj);
                if (iconTable[i].additionalInfo  &&
                    iconTable[i].additionalInfo.firstTimeText){
                        iconTable[i].additionalInfo.firstTimeText = false;
                }
        }
        iconTable[i].firstTime = false;
    }
    return notificationArr;
   
}
export default createNotificationsFromIconTable;





